export default __webpack_public_path__ + "static/media/093-down-arrow-3.b4e134aa.png";